import { Container } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Suspense, useCallback, useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Booking from "src/assets/navbar/booking.svg";
import Contract from "src/assets/navbar/contract.svg";
import Customer from "src/assets/navbar/customer.svg";
import Home from "src/assets/navbar/home.svg";
import Report from "src/assets/navbar/report.svg";
import Setting from "src/assets/navbar/setting.svg";
import Vehicle from "src/assets/navbar/vehicle.svg";
import { useProfile } from "src/auth/Auth";
import Permissions from "src/common_constants/Permission";
import { Role } from "src/common_constants/RoleConstants";
import CustomLoader from "src/shared_components/CustomLoader";
import Invoice from "src/assets/navbar/inovice.svg";
import CustomSvgIcon from "src/shared_components/Icons/CustomSvgIcon";
import Planner from "src/assets/navbar/planner.svg";

import TopNav from "../Nav/TopNav";

export const TOP_NAV_HEIGHT = 64;
const items = [
  {
    title: "Dashboard",
    path: "/Dashboard",
    icon: <CustomSvgIcon src={Home} />,
    requiredPermission: Permissions.DashboardView,
  },
  {
    title: "Customers",
    path: "/Customer",
    icon: <CustomSvgIcon src={Customer} />,
    requiredPermission: Permissions.CustomerView,
  },
  {
    title: "Vehicles",
    path: "/Asset",
    icon: <CustomSvgIcon src={Vehicle} />,
    requiredPermission: Permissions.CustomerView,
  },
  {
    title: "Planner",
    path: "/Planner",
    icon: <CustomSvgIcon src={Planner} />,
    requiredPermission: Permissions.VehicleScheduleView,
  },
  {
    title: "Reservations",
    path: "/Reservation",
    icon: <CustomSvgIcon src={Booking} />,
    requiredPermission: Permissions.BookingView,
  },
  {
    title: "Contracts",
    path: "/Contract",
    icon: <CustomSvgIcon src={Contract} />,
    requiredPermission: Permissions.ContractView,
  },
  {
    title: "Invoice",
    path: "/Invoice",
    icon: <CustomSvgIcon src={Invoice} />,
    requiredPermission: Permissions.InvoiceView,
  },
  {
    title: "Reports",
    path: "/Reports",
    icon: <CustomSvgIcon src={Report} />,
    requiredPermission: Permissions.ReportView,
  },
  {
    title: "Settings",
    path: "/Settings",
    icon: <CustomSvgIcon src={Setting} />,
    requiredPermission: Permissions.CustomerView,
  },
];

const LayoutRoot = styled("div")<{ sideNavWidth: number }>(
  ({ theme, sideNavWidth }) => ({
    display: "flex",
    flex: "1 1 auto",
    maxWidth: "100%",
    [theme.breakpoints.up("lg")]: {
      paddingLeft: sideNavWidth,
    },
  })
);

const LayoutContainer = styled("div")<{ topNavHeight: number }>(
  ({ theme, topNavHeight }) => ({
    display: "flex",
    flex: "1 1 auto",
    flexDirection: "column",
    width: "100%",
    paddingTop: `${topNavHeight}px`,
  })
);

interface LayoutProps {}

export const Layout: React.FC<LayoutProps> = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const { secRoleId } = useProfile();
  const [openNav, setOpenNav] = useState(false);

  const handlePathnameChange = useCallback(() => {
    if (openNav) {
      setOpenNav(false);
    }
  }, [openNav]);

  useEffect(() => {
    handlePathnameChange();
  }, [pathname]);

  const filteredItems = items;

  return (
    <div
      style={{
        minHeight: "100vh",
        background:
          "linear-gradient(180deg, #FFF 0%, #FBFEFF 45.4%, #F8FDFF 63.6%, #F6FCFF 80.49%, #F6FCFF 89.27%, #F4FBFF 100%)",
      }}
    >
      <TopNav TOP_NAV_HEIGHT={TOP_NAV_HEIGHT} items={filteredItems} />

      <LayoutRoot sideNavWidth={0}>
        <LayoutContainer topNavHeight={TOP_NAV_HEIGHT}>
          <Suspense fallback={<CustomLoader />}>
            <Container
              maxWidth={false}
              sx={{
                py: 8,
                pb: 5,
                mb: { md: 0.1, xs: 1.5 },
              }}
            >
              <Outlet />
            </Container>
          </Suspense>
        </LayoutContainer>
      </LayoutRoot>
    </div>
  );
};
